<template>
  <div class="directory-toolbar">
    <template v-if="newActions.length > 0">
      <ActionMenu
        :actions="newActions"
        @action="(action) => $emit('action', action.actionName, selectedItems)"
      >
        <template #button>
          <ActionButton
            :action="newAction"
            size="small"
            hover-background-color="#3F46D6"
            invert-on-hover
            chevron
            show-text
          />
        </template>
      </ActionMenu>
      <div v-if="bulkActions.length > 0" class="divider"></div>
    </template>
    <div v-if="bulkActions.length > 0" class="bulk-container">
      <ActionButton
        v-for="action in bulkActions"
        :key="action.actionName"
        :disabled="selectedItems.length === 0"
        :action="action"
        @action="(action) => $emit('action', action.actionName, selectedItems)"
      />
    </div>
    <template v-if="privileges.isAdmin">
      <div v-if="newActions.length || bulkActions.length" class="divider"></div>
      <ActionButton
        :action="settingAction"
        @action="(action) => $emit('action', action.actionName, [])"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import ActionButton from './ActionButton.vue'
import ActionMenu from './ActionMenu.vue'
import { Action, DirectoryItem } from './types'
import { usePrivileges } from './privileges'
import { toRefs } from 'vue'

type Props = {
  newActions: Action[]
  bulkActions: Action[]
  selectedItems: DirectoryItem[]
}

const props = defineProps<Props>()
const { newActions, bulkActions, selectedItems } = toRefs(props)

defineEmits<{
  (e: 'action', action: string, items: DirectoryItem[]): void
}>()

const privileges = usePrivileges()

const newAction = {
  actionName: 'new',
  labelKey: 'general__text__new',
  icon: 'IconPlusSquareSmall'
}

const settingAction: Action = {
  actionName: 'settings',
  labelKey: 'general__text__settings',
  icon: 'IconTool2'
}
</script>

<style lang="scss" scoped>
.directory-toolbar {
  display: flex;
  padding: 8px 16px;
  gap: 8px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dee2e6;
  color: #1a1a1a;
  align-items: center;

  .divider {
    width: 1px;
    height: 32px;
    background-color: #e0e0e0;
    margin: 0 8px;
  }

  .bulk-container {
    color: #1a1a1a;
    display: flex;
    gap: 8px;
  }
}
</style>
